"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const map_service_1 = require("../../../commons/map.service");
const _4d_mapper_1 = require("4d-mapper");
const application_events_service_1 = require("@src/app/xs/services/events/application-events.service");
const BaseComponent_1 = require("@src/app/commons/BaseComponent");
const material_1 = require("@angular/material");
const router_1 = require("@angular/router");
exports.navTools = Object.freeze({
    DEFAULT: 0,
    FIRST: 1,
    SECOND: 2,
    THIRD: 3
});
class NavToolbarComponent extends BaseComponent_1.BaseComponent {
    constructor(router, snackBar, dialog, mapService, fourD, applicationEvents) {
        super(router, snackBar, dialog);
        this.router = router;
        this.snackBar = snackBar;
        this.dialog = dialog;
        this.mapService = mapService;
        this.fourD = fourD;
        this.applicationEvents = applicationEvents;
        // currently selected tool
        this.selectedTool = false;
        // our list of tools / modes / states
        this.tools = [];
        this.viewer = null;
    }
    ___mapViewer(incoming) {
        this.viewer = incoming.viewer;
        console.log('****** incoming', incoming);
        let me = this;
        setTimeout(() => { me.setMode(exports.navTools.DEFAULT); }, 500);
    }
    ngOnInit() {
        /* this is where we set up and define our tools (in order) */
        this.tools.push({ id: exports.navTools.FIRST, icon: 'mouse-pointer' });
        this.tools.push({ id: exports.navTools.SECOND, icon: 'keyboard' });
        this.tools.push({ id: exports.navTools.THIRD, icon: 'key' });
    }
    /* select and unselect tools */
    selectTool(item) {
        if (this.selectedTool == item) {
            this.unselectTool();
            return;
        }
        this.selectedTool = item;
        this.setMode(item.id);
    }
    unselectTool() {
        console.log('inspect.component :: unselectTool()');
        this.selectedTool = false;
        this.setMode(exports.navTools.DEFAULT);
    }
    setMode(toolId) {
        console.log('****** setMode', toolId, this.viewer);
        let scene = this.viewer['scene'];
        if (scene) {
            switch (toolId) {
                case exports.navTools.FIRST:
                    // insert cesium tweaks here
                    scene.screenSpaceCameraController.enableLook = false;
                    console.log('nav-toolbar::setMode FIRST');
                    break;
                case exports.navTools.SECOND:
                    // insert cesium tweaks here
                    scene.screenSpaceCameraController.enableTilt = false;
                    console.log('nav-toolbar::setMode SECOND');
                    break;
                case exports.navTools.THIRD:
                    // insert cesium tweaks here
                    scene.screenSpaceCameraController.enableZoom = false;
                    console.log('nav-toolbar::setMode THIRD');
                    break;
                default:
                    // insert default cesium tweaks here  
                    scene.screenSpaceCameraController.enableTilt = true;
                    scene.screenSpaceCameraController.enableZoom = true;
                    scene.screenSpaceCameraController.enableZoom = true;
                    console.log('nav-toolbar::setMode DEFAULT');
            }
        }
    }
}
exports.NavToolbarComponent = NavToolbarComponent;
